import { JSEncrypt } from 'jsencrypt';
import dayjs from 'dayjs';
/**
 * 列表数据转换树形数据
 * @param {Array} data 要转换的列表
 * @param {String} id 主键字段字段名
 * @param {String} pid 父字段字段名
 * @returns {Array} 转换后的树数据
 */
export function treeDataTranslate(data, id = 'id', pid = 'parentId') {
    const res = [];
    const temp = {};
    const dataList = data.map(item => {
        return { ...item };
    });
    for (let i = 0; i < dataList.length; i++) {
        const d = dataList[i];
        if (d) {
            temp[d[id]] = dataList[i];
        }
    }
    for (let k = 0; k < dataList.length; k++) {
        const d = dataList[k];
        if (d) {
            if (temp[d[pid]] && d[id] !== d[pid]) {
                if (!temp[d[pid]]['children']) {
                    temp[d[pid]]['children'] = [];
                }
                if (!temp[d[pid]]['_level']) {
                    temp[d[pid]]['_level'] = 1;
                }
                d['_level'] = temp[d[pid]]._level + 1;
                d['_parent'] = d[pid];
                temp[d[pid]]['children'].push(d);
            }
            else {
                res.push(d);
            }
        }
    }
    return res;
}
/**
 * 获取字符串字节长度（中文算2个字符）
 * @param {String} str 要获取长度的字符串
 */
export function getStringLength(str) {
    return str.replace(/[\u4e00-\u9fa5\uff00-\uffff]/g, '**').length;
}
/**
 * 去除字符串首尾空格
 * @param str 输入字符串
 * @returns 去除首尾空格后的字符串，非字符串输入返回空字符串
 */
export function toStringTrim(str) {
    return typeof str === 'string' ? str.trim() : '';
}
/**
 * 商品名称非法字符（黑名单）
 * \p{C}：控制字符/不可见字符（含制表符、换行）；\p{Z}：各类空格（含全角空格）
 * \u3000-\u303F：中文标点（、。《》「」【】等）
 * \u2018-\u201F：中文弯引号 “ ” ‘ ’
 * \uFF01-\uFF0F / \uFF1A-\uFF20 / \uFF3B-\uFF40 / \uFF5B-\uFF65：全角标点与全角符号
 * 末尾为显式半角黑名单：\ & * ? " ' ` | ~ ^ < >
 * 保留中英文、数字及 - _ / . , ( ) + : ; % # @ ! $ = 等常用半角符号
 */
//const GOODS_NAME_ILLEGAL_PATTERN =
'[\\p{C}\\p{Z}\\u3000-\\u303F\\u2018-\\u201F\\uFF01-\\uFF0F\\uFF1A-\\uFF20\\uFF3B-\\uFF40\\uFF5B-\\uFF65\\\\&*?\'"`|~^<>]';
const GOODS_NAME_ILLEGAL_PATTERN = '[\\p{C}\\p{Z}' +
    '\\u3000-\\u303F' + // CJK 标点（、。《》【】〈〉「」等）
    '\\u2010-\\u2027' + // 通用标点：‐‑‒–—―‖‗''‚‛""„‟†‡•…‧
    '\\u2030-\\u205E' + // ‰′″‴‵‶‷‸‹›※‼‽‾‿⁀⁁...⁞
    '\\uFF01-\\uFF0F' + // 全角 ！-／
    '\\uFF1A-\\uFF20' + // 全角 ：-＠
    '\\uFF3B-\\uFF40' + // 全角 ［-｀
    '\\uFF5B-\\uFF65' + // 全角 ｛-･
    '\\uFFE0-\\uFFEE' + // 全角 ￠-￮（￥ 等）
    '\\u00B7' + // 间隔号 ·
    '\\u00A1-\\u00BF' + // 拉丁标点 ¡¢£...¿（按需，可删）
    '\\\\&*?\'"`|~^<>' +
    ']';
// 拆成两个 RegExp：带 g 的正则用 test() 会因 lastIndex 残留导致重复调用结果不一致
const goodsNameReplaceReg = new RegExp(GOODS_NAME_ILLEGAL_PATTERN, 'gu');
const goodsNameTestReg = new RegExp(GOODS_NAME_ILLEGAL_PATTERN, 'u');
/**
 * 商品名称输入过滤：剔除空格、换行、制表符、全角标点及非法符号（静默过滤，不提示）
 * @param val 原始输入
 * @returns 过滤后的商品名称，非字符串输入返回空字符串
 */
export function filterGoodsName(val) {
    return typeof val === 'string' ? val.replace(goodsNameReplaceReg, '') : '';
}
/**
 * 商品名称是否包含非法字符（用于校验兜底）
 * @param val 输入值
 * @returns 含非法字符返回 true
 */
export function hasIllegalGoodsNameChar(val) {
    return typeof val === 'string' && goodsNameTestReg.test(val);
}
/**
 * 判断数组是否为空（null、undefined 或 length === 0）
 * @param arr 要判断的数组
 * @returns 是否为空
 */
export function isEmptyArray(arr) {
    return arr == null || !Array.isArray(arr) || arr.length === 0;
}
/**
 * 判断数组是否不为空
 * @param arr 要判断的数组
 * @returns 是否不为空
 */
export function isNotEmptyArray(arr) {
    return !isEmptyArray(arr);
}
/**
 * 判断对象是否为空（null、undefined 或没有自身属性）
 * @param obj 要判断的对象
 * @returns 是否为空
 */
export function isEmptyObject(obj) {
    if (obj == null)
        return true;
    if (!isObject(obj))
        return true;
    return Object.keys(obj).length === 0;
}
/**
 * 判断对象是否不为空
 * @param obj 要判断的对象
 * @returns 是否不为空
 */
export function isNotEmptyObject(obj) {
    return !isEmptyObject(obj);
}
/**
 * 将 null 或 undefined 转换为空字符串，其他值原样返回
 * @param value 任意值
 * @returns 转换后的值
 */
export function nullToEmpty(value) {
    if (value == null)
        return '';
    return value;
}
/**
 * 判断值是否为空（字符串、数组、对象、null、undefined）
 * @param value 要判断的值
 * @returns 是否为空
 */
export function isEmpty(value) {
    if (value == null || value == undefined)
        return true;
    if (typeof value === 'string')
        return value === '';
    if (Array.isArray(value))
        return value.length === 0;
    if (isObject(value))
        return Object.keys(value).length === 0;
    return false;
}
/**
 * 判断值是否不为空
 * @param value 要判断的值
 * @returns 是否不为空
 */
export function isNotEmpty(value) {
    return !isEmpty(value);
}
/**
 * 获取uuid
 */
export function getUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const random = Math.random() * 16;
        return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16);
    });
}
export function stringCase(str, type) {
    if (str == null || str === '')
        return str;
    if (type === 0) {
        // 首字母小写
        return str.slice(0, 1).toLowerCase() + str.slice(1);
    }
    else {
        // 首字母大写
        return str.slice(0, 1).toUpperCase() + str.slice(1);
    }
}
/**
 * 大小驼峰变换函数
 * @param name 要转换的字符串
 * @param type 转换的类型0：转换成小驼峰，1：转换成大驼峰
 */
export function nameTranslate(name, type) {
    name = name.toLowerCase();
    let nameArray = name.split('_');
    nameArray.forEach((item, index) => {
        if (index === 0) {
            name = type === 1 ? item.slice(0, 1).toUpperCase() + item.slice(1) : item;
        }
        else {
            name = name + item.slice(0, 1).toUpperCase() + item.slice(1);
        }
    });
    nameArray = name.split('-');
    nameArray.forEach((item, index) => {
        if (index === 0) {
            name = type === 1 ? item.slice(0, 1).toUpperCase() + item.slice(1) : item;
        }
        else {
            name = name + item.slice(0, 1).toUpperCase() + item.slice(1);
        }
    });
    return name;
}
/**
 * 通过id从树中获取指定的节点
 * @param {Object} node 根节点
 * @param {String|Nubmer} id 键值
 * @param {Array} list 保存查询路径
 * @param {String} idKey 主键字段名
 * @param {String} childKey 子节点字段名
 */
function findNode(node, id, list, idKey = 'id', childKey = 'children') {
    if (Array.isArray(list))
        list.push(node);
    const nodeValue = node[idKey]?.toString();
    const targetValue = id?.toString();
    if (nodeValue === targetValue) {
        return node;
    }
    if (node[childKey] != null && Array.isArray(node[childKey])) {
        for (let i = 0; i < node[childKey].length; i++) {
            const tempNode = findNode(node[childKey][i], id, list, idKey, childKey);
            if (tempNode)
                return tempNode;
        }
    }
    if (Array.isArray(list))
        list.pop();
}
/**
 * 通过id返回从根节点到指定节点的路径
 * @param {Array} treeRoot 树根节点数组
 * @param {*} id 要查询的节点的id
 * @param {*} idKey 主键字段名
 * @param {*} childKey 子节点字段名
 */
export function findTreeNodeObjectPath(treeRoot, id, idKey = 'id', childKey = 'children') {
    const tempList = [];
    for (let i = 0; i < treeRoot.length; i++) {
        if (findNode(treeRoot[i], id, tempList, idKey, childKey)) {
            return tempList;
        }
    }
    return [];
}
export function findTreeNodePath(treeRoot, id, idKey = 'id', childKey = 'children') {
    return (findTreeNodeObjectPath(treeRoot, id, idKey, childKey) || []).map(item => item[idKey]);
}
/**
 * 通过id从树中查找节点
 * @param {Array} treeRoot 根节点数组
 * @param {*} id 要查找的节点的id
 * @param {*} idKey 主键字段名
 * @param {*} childKey 子节点字段名
 */
export function findTreeNode(treeRoot, id, idKey = 'id', childKey = 'children') {
    for (let i = 0; i < treeRoot.length; i++) {
        const tempNode = findNode(treeRoot[i], id, undefined, idKey, childKey);
        if (tempNode)
            return tempNode;
    }
}
export function traverseTree(root, callback, childKey = 'children') {
    function traverseNode(node) {
        if (typeof callback === 'function')
            callback(node);
        if (Array.isArray(node[childKey])) {
            node[childKey].forEach((suNode) => {
                traverseNode(suNode);
            });
        }
    }
    if (Array.isArray(root)) {
        root.forEach(node => {
            traverseNode(node);
        });
    }
}
/**
 * 把Object转换成query字符串
 * @param {Object} params 要转换的Object
 */
export function objectToQueryString(params) {
    if (params == null) {
        return null;
    }
    else {
        return Object.keys(params)
            .map(key => {
            if (params[key] !== undefined) {
                return `${key}=${params[key]}`;
            }
            else {
                return undefined;
            }
        })
            .filter(item => item != null)
            .join('&');
    }
}
/**
 * 从数组中查找某一项
 * @param {Array} list 要查找的数组
 * @param {String} id 要查找的节点id
 * @param {String} idKey 主键字段名（如果为null则直接比较）
 * @param {Boolean} removeItem 是否从数组中移除查找到的节点
 * @returns {Object} 找到返回节点，没找到返回undefined
 */
export function findItemFromList(list, id, idKey = null, removeItem = false) {
    if (Array.isArray(list) && list.length > 0 && id != null) {
        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            if (((idKey == null || idKey === '') && item.toString() === id) ||
                (idKey != null && item[idKey] === id)) {
                if (removeItem)
                    list.splice(i, 1);
                return item;
            }
        }
    }
    return null;
}
/**
 * 将数据保存到sessionStorage
 * @param {*} key sessionStorage的键值
 * @param {*} value 要保存的数据
 */
export function setObjectToSessionStorage(key, value) {
    if (key == null || key === '')
        return false;
    if (value == null) {
        window.sessionStorage.removeItem(key);
        return true;
    }
    else {
        const jsonObj = {
            data: value,
        };
        window.sessionStorage.setItem(key, JSON.stringify(jsonObj));
        return true;
    }
}
/**
 * 从sessionStorage里面获取数据
 * @param {String} key 键值
 * @param {*} defaultValue 默认值
 */
export function getObjectFromSessionStorage(key, defaultValue) {
    let jsonObj;
    try {
        const val = sessionStorage.getItem(key);
        if (val == null)
            return defaultValue;
        jsonObj = JSON.parse(val);
        jsonObj = (jsonObj || {}).data;
    }
    catch (e) {
        jsonObj = defaultValue;
    }
    return jsonObj != null ? jsonObj : defaultValue;
}
/**
 * 判读字符串是否一个数字
 * @param {String} str 要判断的字符串
 */
export function isNumber(str) {
    const num = Number.parseFloat(str);
    if (Number.isNaN(num))
        return false;
    return num.toString() === str;
}
/**
 * 生成随机数
 * @param {Integer} min 随机数最小值
 * @param {Integer} max 随机数最大值
 */
export function random(min, max) {
    const base = Math.random();
    return min + base * (max - min);
}
/**
 * 加密
 * @param {*} value 要加密的字符串
 */
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDnERJCfHjjoWPPNWwoKBX7pcrJPNu24WwYzBysH0JA93lm67roirqZxg4uo+8v3LXFq+on5XIVpf58JbdwP2ONWfUvKn76i+PmmAoOULrEgKwVMFfWHV7Kf74DQcaV7hMdTQx0IRfqyBBYxzYuZT8tZuDiEgqb48aQluWpxeX8QQIDAQAB';
export function encrypt(value) {
    if (value == null || value === '')
        return null;
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + publicKey + '-----END PUBLIC KEY-----');
    var ps = encrypt.encrypt(value);
    return encodeURIComponent(encrypt.encrypt(value));
}
export function getToken() {
    return sessionStorage.getItem('token');
}
export function setToken(token) {
    if (token == null || token === '') {
        sessionStorage.removeItem('token');
    }
    else {
        sessionStorage.setItem('token', token);
    }
}
export function getRefreshToken() {
    return sessionStorage.getItem('refreshToken');
}
export function setRefreshToken(token) {
    if (token == null || token === '') {
        sessionStorage.removeItem('refreshToken');
    }
    else {
        sessionStorage.setItem('refreshToken', token);
    }
}
export function getAppId() {
    const appId = sessionStorage.getItem('appId');
    return appId != null ? appId : undefined;
}
export function setAppId(appId) {
    if (appId == null || appId === '') {
        sessionStorage.removeItem('appId');
    }
    else {
        sessionStorage.setItem('appId', appId);
    }
}
/**
 * 提取请求错误信息（统一各页面 catch 里的文案兜底写法）
 *
 * 兼容 commonRequest / axios 拦截器的多种 reject 形态：
 * - Error：axios 响应拦截器 reject 的 new Error(errorMessage)
 * - { errorMessage } / { data: { errorMessage } }：commonRequest 在 success=false 时 reject 原始响应体
 * - 字符串：部分场景直接 reject 文案
 *
 * @param e catch 到的异常
 * @param fallback 取不到有效文案时的兜底提示
 */
export function getErrMsg(e, fallback = '操作失败') {
    if (e == null || e === '')
        return fallback;
    if (typeof e === 'string')
        return e;
    const err = e;
    const msg = err.errorMessage || err.data?.errorMessage || err.message;
    return typeof msg === 'string' && msg ? msg : fallback;
}
/**
 * 保存导出文件到本地（Excel 等）
 *
 * downloadBlob 使用 responseType=blob，axios 拦截器对 Blob 不校验 success，
 * 因此后端 BusinessException 返回的 JSON（{ errorMessage }）会被原样当成文件下载。
 * 这里先判定 Content-Type，把 JSON 报文还原成异常抛出，由调用方统一提示。
 *
 * @param blob downloadBlob 返回的二进制流
 * @param fileName 下载文件名
 */
export async function saveExportFile(blob, fileName) {
    if (blob == null)
        throw new Error('未获取到导出文件内容');
    if (typeof blob.type === 'string' && blob.type.includes('application/json')) {
        let message = '导出失败';
        try {
            message = JSON.parse(await blob.text())?.errorMessage || message;
        }
        catch {
            // 报文不是预期格式时保留兜底文案
        }
        throw new Error(message);
    }
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    if (typeof link.download === 'undefined') {
        link.setAttribute('target', '_blank');
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
export function traversalTree(treeNode, callback, childrenKey = 'children') {
    if (treeNode != null &&
        Array.isArray(treeNode[childrenKey]) &&
        treeNode[childrenKey].length > 0) {
        treeNode[childrenKey].forEach((childNode) => {
            traversalTree(childNode, callback, childrenKey);
        });
    }
    return typeof callback === 'function' ? callback(treeNode) : undefined;
}
export class TreeTableImpl {
    options;
    dataList;
    dataMap;
    checkedRows;
    constructor(dataList, options) {
        this.options = {
            idKey: options ? options.idKey : 'id',
            nameKey: options ? options.nameKey : 'name',
            parentIdKey: options ? options.parentIdKey : 'parentId',
            isLefeCallback: options ? options.isLefeCallback : undefined,
            checkStrictly: options ? options.checkStrictly : false,
        };
        this.dataList = Array.isArray(dataList) ? dataList : [];
        this.dataMap = new Map();
        this.dataList.forEach(item => {
            this.dataMap.set(item[this.options.idKey], item);
        });
        // 表格选中行
        this.checkedRows = undefined;
        this.onCheckedRowChange = this.onCheckedRowChange.bind(this);
    }
    /**
     * 过滤表格数据
     * @param {string} filterString 过滤条件字符串
     * @param {boolean} onlyChecked 是否只显示选中节点
     * @returns {array} 过滤后的表格数据列表
     */
    getFilterTableData(filterString, onlyChecked = false) {
        const { idKey, nameKey, parentIdKey, isLefeCallback } = this.options;
        const tempMap = new Map();
        const parentIdList = [];
        this.dataList.forEach(item => {
            if ((filterString == null ||
                filterString === '' ||
                item[nameKey].indexOf(filterString) !== -1) &&
                (!onlyChecked || (this.checkedRows != null && this.checkedRows.get(item[idKey])))) {
                if (!isLefeCallback || !isLefeCallback(item)) {
                    parentIdList.push(item[idKey]);
                }
                // 将命中节点以及它的父节点都设置为命中
                let tempItem = item;
                do {
                    tempMap.set(tempItem[idKey], tempItem);
                    tempItem = this.dataMap.get(tempItem[parentIdKey]);
                } while (tempItem != null);
            }
        });
        return this.dataList.map(item => {
            let disabled = true;
            if (parentIdList.indexOf(item[parentIdKey]) !== -1 || tempMap.get(item[idKey]) != null) {
                if (parentIdList.indexOf(item[parentIdKey]) !== -1 &&
                    (isLefeCallback == null || !isLefeCallback(item))) {
                    parentIdList.push(item[idKey]);
                }
                disabled = false;
            }
            return {
                ...item,
                __disabled: disabled,
            };
        });
    }
    /**
     * 获取表格树数据，计算选中状态
     * @param {array} dataList 表格列表数据
     */
    getTableTreeData(dataList, checkedRows) {
        const { idKey, parentIdKey, checkStrictly } = this.options;
        let treeData = [];
        function calcPermCodeTreeAttribute(treeNode, checkedRows) {
            const checkedItem = checkedRows == null ? null : checkedRows.get(treeNode[idKey]);
            treeNode.__checked = checkedItem != null;
            // 是否所有子权限字都被选中
            let allChildChecked = true;
            // 是否任意子权限字被选中
            let hasChildChecked = false;
            // 如果存在子权限字
            if (Array.isArray(treeNode.children) && treeNode.children.length > 0) {
                treeNode.children.forEach((item) => {
                    const isChecked = calcPermCodeTreeAttribute(item, checkedRows);
                    hasChildChecked = hasChildChecked || isChecked;
                    allChildChecked = allChildChecked && isChecked;
                });
            }
            else {
                allChildChecked = false;
            }
            treeNode.__indeterminate = !checkStrictly && hasChildChecked && !allChildChecked;
            treeNode.__checked = treeNode.__checked || (allChildChecked && !checkStrictly);
            return treeNode.__checked || treeNode.__indeterminate;
        }
        if (Array.isArray(dataList)) {
            treeData = treeDataTranslate(dataList.map(item => {
                return { ...item };
            }), idKey, parentIdKey);
            treeData.forEach(item => {
                calcPermCodeTreeAttribute(item, checkedRows);
            });
        }
        return treeData;
    }
    /**
     * 树表格行选中状态改变
     * @param {object} row 选中状态改变行数据
     */
    onCheckedRowChange(row) {
        if (this.checkedRows == null) {
            this.checkedRows = new Map();
        }
        else {
            const temp = new Map();
            this.checkedRows.forEach((item, key) => {
                temp.set(key, item);
            });
            this.checkedRows = temp;
        }
        const { idKey } = this.options;
        if (!row.__checked || row.__indeterminate) {
            // 节点之前未被选中或者之前为半选状态，修改当前节点以及子节点为选中状态
            this.checkedRows.set(row[idKey], row);
            if (Array.isArray(row.children) && !this.options.checkStrictly) {
                row.children.forEach((childNode) => {
                    traversalTree(childNode, node => {
                        this.checkedRows?.set(node[idKey], node);
                    });
                });
            }
        }
        else {
            // 节点之前为选中状态，修改节点以及子节点为未选中状态
            this.checkedRows.delete(row[idKey]);
            if (Array.isArray(row.children) && !this.options.checkStrictly) {
                row.children.forEach((childNode) => {
                    traversalTree(childNode, node => {
                        this.checkedRows?.delete(node[idKey]);
                    });
                });
            }
        }
    }
    /**
     * 获取所有选中的权限字节点
     * @param {array} treeData 树数据
     * @param {boolean} includeHalfChecked 是否包含半选节点，默认为false
     * @returns {array} 选中节点列表
     */
    getCheckedRows(treeData, includeHalfChecked = false) {
        const checkedRows = [];
        function traversalCallback(node) {
            if (node == null)
                return;
            if (node.__checked || (includeHalfChecked && node.__indeterminate)) {
                checkedRows.push(node);
            }
        }
        if (Array.isArray(treeData) && treeData.length > 0) {
            treeData.forEach(permCode => {
                traversalTree(permCode, traversalCallback, 'children');
            });
        }
        return checkedRows;
    }
    /**
     * 设置选中节点
     * @param {array} checkedRows
     */
    setCheckedRows(checkedRows) {
        this.checkedRows = new Map();
        if (Array.isArray(checkedRows)) {
            checkedRows.forEach(item => {
                const node = this.dataMap.get(item[this.options.idKey]);
                if (node != null) {
                    this.checkedRows?.set(node[this.options.idKey], node);
                }
            });
        }
    }
    /**
     * 根据id获取表格行
     * @param {*} id
     */
    getTableRow(id) {
        return this.dataMap.get(id);
    }
}
export function formatDate(date, formatString) {
    return dayjs(date).format(formatString);
}
export function parseDate(date, formatString) {
    return dayjs(date, formatString);
}
export function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        if (file == null)
            return reject();
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
            resolve(e.target?.result);
        };
        reader.onerror = e => {
            reject(e);
        };
    });
}
export function getObjectValue(data, fieldName) {
    if (data == null)
        return undefined;
    if (fieldName == null || fieldName === '')
        return data;
    const fieldPath = fieldName.split('.');
    let tempValue = data;
    if (Array.isArray(fieldPath)) {
        fieldPath.forEach(key => {
            if (tempValue != null) {
                tempValue = tempValue[key];
            }
        });
    }
    return tempValue;
}
// 判断输入值是否一个Object
export function isObject(obj) {
    return obj != null && typeof obj === 'object' && obj.toString() === '[object Object]';
}
function copyObject(obj) {
    if (obj == null)
        return obj;
    return JSON.parse(JSON.stringify(obj));
}
export function deepMerge(obj1, obj2) {
    const tempObj = copyObject(obj1);
    if (obj2 != null) {
        Object.keys(obj2).forEach(key => {
            const val2 = obj2[key];
            const val1 = tempObj[key];
            if (isObject(val2)) {
                // 如果两个值都是对象，则递归合并
                if (isObject(val1)) {
                    tempObj[key] = deepMerge(val1, val2);
                }
                else {
                    tempObj[key] = copyObject(val2);
                }
            }
            else if (Array.isArray(val2)) {
                // 如果两个值都是数组，则合并数组
                if (Array.isArray(val1)) {
                    tempObj[key] = val2.map((arrVal2, index) => {
                        const arrVal1 = val1[index];
                        if (isObject(arrVal1)) {
                            return deepMerge(arrVal1, arrVal2);
                        }
                        else {
                            return arrVal2;
                        }
                    });
                }
                else {
                    tempObj[key] = copyObject(val2);
                }
            }
            else {
                // 直接覆盖
                tempObj[key] = val2;
            }
        });
    }
    return tempObj;
}
/**
 * 递归地将对象中所有空字符串('')转换为 null
 * 支持处理嵌套对象和数组
 * @param data 要处理的数据
 * @returns 处理后的数据
 */
export function convertEmptyStringToNull(data) {
    // 处理 null/undefined 情况
    if (data === null || data === undefined)
        return data;
    // 如果是数组，遍历每一项
    if (Array.isArray(data)) {
        return data.map(item => convertEmptyStringToNull(item));
    }
    // 如果是普通对象，遍历每个属性
    if (isObject(data)) {
        const result = {};
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                const value = data[key];
                // 核心：空字符串转 null，其他值继续递归处理
                result[key] = value === '' ? null : convertEmptyStringToNull(value);
            }
        }
        return result;
    }
    // 基础类型直接返回
    return data;
}
